import { useDispatch } from 'react-redux';
import './css/app.css'
import './css/main.css'
import './css/common.css'
import './css/payment.css'
import { useState, useEffect, useRef, useCallback, useMemo, Fragment } from 'react';
import { Link, useNavigate } from "react-router-dom"
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { MessageModal } from './component/modal/modal';

import { CountAmount, CountSelect, DownloadBtn, TotalAmount, TotalAmountCount } from './component/btn/btn';
import List from './component/list/list';
import { LoadingModal } from './component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import html2canvas from 'html2canvas';

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchDateMobile } from './component/search/search';
import dayjs from 'dayjs';
import { formatDateTime, changeNum, getImageSrc } from './common/function';
import { ChevronDown, ChevronUp } from 'lucide-react';

import useWindowSize from './hook/useWindowSize'

function UrlHistory() {
    let navigate = useNavigate();
    let dispatch = useDispatch()

    const { Rwidth, Rheight } = useWindowSize();

    const [loading, setLoading] = useState(true)
    const [page, setPage] = useState(1)
    const [totalPage, setTotalPage] = useState(0)
    const [maxFirstPage, setMaxFirstPage] = useState(40)
    const [amount, setAmount] = useState([1000000, 50000])

    const [listData, setListData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [clickData, setClickData] = useState([])
    const [reload, setReload] = useState(false)


    useEffect(() => {
        dispatch(change_Current_Location("URL상품결제내역"))
        dispatch(changeHeaderTitle({
            mainTitle: "URL상품결제내역",
            subTitle: ""
        }))
        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    // 기간 포맷
    const inputRef = useRef(null);   // 숨겨진(또는 실제) datepicker input
    const pickerRef = useRef(null);  // Litepicker instance

    // 날짜 상태 (초기값: 이번 달)
    const [preDate, setPreDate] = useState(dayjs().startOf('month').format('YYYY/MM/DD'));
    const [nextDate, setNextDate] = useState(dayjs().endOf('month').format('YYYY/MM/DD'));

    // ★ 핵심: inputRef.current(또는 화면폭) 바뀔 때마다 재부착
    useEffect(() => {
        const el = inputRef.current;
        if (!el) return;

        // 기존 인스턴스 정리
        if (pickerRef.current) {
            pickerRef.current.destroy();
            pickerRef.current = null;
        }

        // 새 인스턴스 부착
        const picker = new Litepicker({
            element: el,
            lang: "ko",
            singleMode: false,
            format: "YYYY/MM/DD",
            numberOfMonths: 2,
            numberOfColumns: 2,
            showWeekNumbers: true,
            dropdowns: { minYear: 2020, maxYear: 2030, months: true, years: true },
            setup: (p) => {
                p.on("selected", (start, end) => {
                    setPreDate(start.format("YYYY/MM/DD"));
                    setNextDate(end.format("YYYY/MM/DD"));
                });
            },
        });

        pickerRef.current = picker;

        // 현재 선택 범위 반영
        picker.setDateRange(preDate, nextDate);

        // cleanup
        return () => {
            picker.destroy();
            pickerRef.current = null;
        };
        // 화면 레이아웃 전환시에도 재초기화를 원하면 Rwidth 같은 뷰포트 상태도 deps에 포함
    }, [inputRef.current /*, Rwidth */]);

    // 날짜 상태가 바뀌면 picker에도 반영 (인스턴스가 살아있을 때만)
    useEffect(() => {
        pickerRef.current?.setDateRange(preDate, nextDate);
    }, [preDate, nextDate]);

    // 공용 setter
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate);
        setNextDate(endDate);
        pickerRef.current?.setDateRange(startDate, endDate);
        setPage(1);
    };

    useEffect(() => {
        ListData()
    }, [page, preDate, nextDate])

    const ListData = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/url-pay/list", {
            withCredentials: true,
            params: {
                page: page,
                limit: maxFirstPage,
                startDate: preDate,
                endDate: nextDate,
            }
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                if (page === 1) {
                    setListData(tmp?.data?.items ?? []);
                }
                else {
                    setListData((prev) => [...prev, ...tmp?.data?.items ?? []]);
                }

                // setAmount([Number(tmp?.data?.summary?.total_amount), Number(tmp?.data?.summary?.cancel_amount)])
                setTotalPage(tmp?.data?.pagination?.totalCount ?? 0)
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const tableHeaderData = [
        { "no": 1, "text": "상품코드", "width": "70px", "textAlign": "center" },
        { "no": 2, "text": "상품명", "width": "120px", "textAlign": "center" },
        { "no": 3, "text": "금액", "width": "70px", "textAlign": "center" },
        { "no": 3, "text": "수량", "width": "50px", "textAlign": "center" },
        { "no": 4, "text": "구매자명", "width": "70px", "textAlign": "center" },
        { "no": 5, "text": "주소", "width": "200px", "textAlign": "center" },
        { "no": 6, "text": "이메일", "width": "170px", "textAlign": "center" },
        { "no": 7, "text": "전화번호", "width": "110px", "textAlign": "center" },
        { "no": 8, "text": "결제일", "width": "130px", "textAlign": "center" },
        { "no": 9, "text": "상태", "width": "60px", "textAlign": "center" },
    ];

    useEffect(() => {
        let tableBodyData = [];
        if (listData) {
            let list = listData ?? []

            for (let i = 0; i < list.length; i++) {
                let data = list[i];

                let rowData = [
                    { "no": 1, "text": data.productCode, "width": "70px", "textAlign": "left" },
                    { "no": 2, "text": data.productName, "width": "120px", "textAlign": "left" },
                    { "no": 3, "text": changeNum(Number(data.price)), "width": "70px", "textAlign": "right" },
                    { "no": 3, "text": changeNum(Number(data.quantity)), "width": "50px", "textAlign": "right" },
                    { "no": 4, "text": data.name, "width": "70px", "textAlign": "center" },
                    { "no": 5, "text": data.address, "width": "200px", "textAlign": "left" },
                    { "no": 6, "text": data.email, "width": "170px", "textAlign": "left" },
                    { "no": 7, "text": data.tel, "width": "110px", "textAlign": "center" },
                    { "no": 8, "text": data.orderDate ? dayjs(data.orderDate).add(9, "hour").format("YYYY-MM-DD HH:mm") : "", "width": "130px", "textAlign": "center" },
                    { "no": 9, "text": data.isCancelled ? "취소" : "정상", "width": "60px", "textAlign": "center" },
                ]

                rowData.id = data.id
                tableBodyData.push(rowData);
            }
            setCombineData(tableBodyData)
        }
    }, [listData, reload]);

    const [state, setState] = useState(Rwidth > 768 ? true : false)
    const [dropDown, setDropDown] = useState(false)

    useEffect(() => {
        if (Rwidth > 768) {
            setState(true)
        }
        else {
            setState(false)
        }
    }, [Rwidth])

    const excelBtn = () => {

    }

    const isMobile = Rwidth <= 767;

    // 스크롤 컨테이너(모바일 영역) 참조
    const mobileScrollRef = useRef(null);

    // observer 인스턴스 보관
    const ioRef = useRef(null);

    // sentinel을 바꿀 때마다 자동으로 observe/cleanup 되는 콜백 ref
    const setSentinelRef = useCallback((node) => {
        // 이전 관찰 중단
        if (ioRef.current) {
            ioRef.current.disconnect();
            ioRef.current = null;
        }
        if (!node) return;

        // root: 모바일은 내부 스크롤 박스, 데스크톱은 기본(뷰포트 또는 외부 스크롤러)
        const rootEl = isMobile ? mobileScrollRef.current : null;

        ioRef.current = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && totalPage >= page * maxFirstPage) {
                setPage((prev) => prev + 1);
            }
        }, {
            root: rootEl,            // 중요: 모바일에서 내부 스크롤 컨테이너 지정
            rootMargin: "200px 0px", // 여유롭게 미리 로드
            threshold: 0
        });

        ioRef.current.observe(node);
    }, [isMobile, totalPage, page, maxFirstPage]);

    // list 변경·레이아웃 전환 시에도 sentinel 재연결 보장 (콜백 ref가 처리하지만 안전망)
    useEffect(() => {
        return () => { ioRef.current?.disconnect(); };
    }, []);

    const sortedList = useMemo(
        () => [...listData].sort((a, b) => dayjs(b.orderDate) - dayjs(a.orderDate)),
        [listData]
    );

    let lastKey = null;

    // 서버 시간 UTC+0 → 한국시간(KST) UTC+9
    const toKST = (s) => (s ? dayjs(s).add(9, "hour") : dayjs());
    const dateKey = (s) => toKST(s).format("YY.MM.DD"); // 예: 25.08.01
    const timeStr = (s) => toKST(s).format("HH:mm");    // 예: 12:45

    return (
        <>
            {loading ? <LoadingModal /> : ""}
            {
                Rwidth > 767
                    ?
                    <div class="content" id="contents">
                        <div class="paylist">
                            <form id="tabulator-html-filter-form" class="xl:flex sm:mr-auto">
                                <div class="form_filter w-full">
                                    <SearchDate
                                        type={"날짜"}
                                        inputRef={inputRef}
                                        setDateRange={setDateRange}
                                        preDate={preDate}
                                        nextDate={nextDate}
                                    />
                                </div>
                            </form>
                            <div className="intro-y box p-5 mt-2">
                                <div className="tabulator_summary_wrap" style={{ height: "auto", alignItems: 'flex-end', justifyContent: "space-between" }}>

                                    {
                                        state
                                            ?
                                            <div style={{ display: "flex", gap: "0.25rem", width: "100%" }}>
                                                <div className="input_wrap" style={{ background: "#d7e3cf" }}>
                                                    <label>결제건수 :</label>
                                                    <input id="confirm_amt" type="text" className="form-control" value={changeNum(totalPage)} readonly="" disabled="" />
                                                </div>
                                                <div className="input_wrap" style={{ background: "#d2e4fb" }}>
                                                    <label>총금액 :</label>
                                                    <input id="canceled_amt" type="text" className="form-control" value={changeNum(totalPage)} readonly="" disabled="" />
                                                </div>
                                            </div>
                                            :
                                            <div style={{ width: "100%" }}>
                                                <div className="input_wrap" style={{ background: "#d2e4fb", position: "relative" }} onClick={() => setDropDown(e => !e)}>
                                                    <label>총금액 :</label>
                                                    <input id="tot_amt" type="text" className="form-control" value={changeNum(totalPage)} readonly="" disabled="" style={{ paddingRight: "13px" }} />
                                                    {
                                                        dropDown
                                                            ?
                                                            <button type="button" className="btn_more" style={{ position: "absolute", top: "50%", right: "5px", transform: "translateY(-50%)" }}>
                                                                <ChevronUp />
                                                            </button>
                                                            :
                                                            <button type="button" className="btn_more" style={{ position: "absolute", top: "50%", right: "5px", transform: "translateY(-50%)" }}>
                                                                <ChevronDown />
                                                            </button>
                                                    }
                                                </div>
                                                {
                                                    dropDown
                                                        ?
                                                        <>
                                                            <div className="input_wrap" style={{ background: "#d7e3cf" }}>
                                                                <label>결제건수 :</label>
                                                                <input id="confirm_amt" type="text" className="form-control" value={changeNum(totalPage)} readonly="" disabled="" style={{ paddingRight: "13px" }} />
                                                            </div>
                                                        </>
                                                        :
                                                        ""
                                                }
                                            </div>
                                    }

                                    <DownloadBtn text={"엑셀 다운로드"} onClick={excelBtn} />
                                </div>
                                <div style={{ maxWidth: "1000px", width: "100%" }}>
                                    <List
                                        tableHeaderData={tableHeaderData}
                                        tableBodyData={totalPage ?? 0}
                                        filter_tableBodyData={combineData}
                                        page={page}
                                        setPage={setPage}
                                        maxFirstPage={maxFirstPage}
                                        listType={true}
                                        observerRef={setSentinelRef}
                                        nonePage={false}
                                        scrollState={true}
                                        height={"700px"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div style={{ marginTop: "3.5rem", background: "#fff", minHeight: "calc(100dvh - 3.5rem)" }}>
                        <div style={{ padding: "20px 15px", borderBottom: "6px solid #f1f1f1" }}>
                            <SearchDateMobile
                                type={"날짜"}
                                inputRef={inputRef}
                                setDateRange={setDateRange}
                                preDate={preDate}
                                nextDate={nextDate}
                            />
                        </div>
                        <div style={{ padding: "15px 15px 10px", borderBottom: "6px solid #f1f1f1" }}>
                            <div style={{ fontSize: "13px", color: "#a9a9ab", fontWeight: "500", marginBottom: "3px" }}>{`${preDate}~${nextDate}`}</div>
                            {false && (
                                <div style={{ padding: "20px 12px", background: "#f5f6f8", borderRadius: "8px" }}>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                        <div>매출 합계</div>
                                        <div>
                                            <span>{changeNum(0)}</span>
                                            <span style={{ marginLeft: "2px" }}>원</span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div style={{ padding: "0px", borderBottom: "6px solid #f1f1f1", height: "calc(100dvh - 310px)", overflow: "scroll" }}>
                            {sortedList.map((item, i) => {
                                const dKey = dateKey(item.orderDate);
                                const tStr = timeStr(item.orderDate);
                                const showHeader = dKey !== lastKey;
                                lastKey = dKey;

                                return (
                                    <Fragment key={item.trx_id ?? i}>
                                        {showHeader &&
                                            <div
                                                style={{
                                                    background: "#f1f1f1",
                                                    textAlign: "center",
                                                    padding: "4px",
                                                    fontWeight: "500"
                                                }}
                                            >{dKey}</div>}

                                        {/* 시간만 왼쪽에 찍고 싶다면 timeStr을 prop으로 넘기세요 */}
                                        <MobileListItem
                                            item={item}
                                        />
                                    </Fragment>
                                );
                            })}
                            <div ref={setSentinelRef} style={{ height: '1px' }}></div>
                        </div>
                    </div>
            }
        </>
    )
}

function MobileListItem({ item, onToggleShip }) {
    const [shipped, setShipped] = useState(!!item.shipped);
    const isCancelled = !!item.isCancelled;
    // 서버 시간 UTC+0 → 한국시간(KST) +9시간
    const kst = item.orderDate ? dayjs(item.orderDate).add(9, "hour") : dayjs();
    const dateStr = kst.format("YY.MM.DD");
    const timeStr = kst.format("HH:mm");
    const price = Number(item.price || 0);
    const fmt = (n) => (typeof changeNum === "function" ? changeNum(n) : n.toLocaleString());

    const handleToggle = () => {
        const next = !shipped;
        setShipped(next);
        onToggleShip?.(item, next);
    };

    const badge = shipped
        ? { text: "배송완료", bg: "#ecfdf5", color: "#065f46" }
        : { text: "배송대기", bg: "#f3f4f6", color: "#374151" };

    return (
        <div style={{ padding: "0 15px" }}>
            <article className="mobile-ship-item" style={isCancelled ? { opacity: 0.75, background: "#fafafa" } : undefined}>
                {/* 상단: 날짜/상태/금액 */}
                <header className="mobile-ship-head">
                    <div className="mobile-ship-date">
                        <span className="mobile-ship-date-pill">{timeStr}</span>
                    </div>

                    <div className="mobile-ship-head-right">
                        {isCancelled && (
                            <span className="mobile-ship-badge" style={{ background: "#fef2f2", color: "#b91c1c", marginRight: "6px" }}>
                                취소
                            </span>
                        )}
                        {false && (
                            <span
                                className="mobile-ship-badge"
                                style={{ background: badge.bg, color: badge.color }}
                            >
                                {badge.text}
                            </span>
                        )}
                        <span className="mobile-ship-price">{fmt(price)}원</span>
                    </div>
                </header>

                {/* 본문: 썸네일 + 정보 */}
                <div style={{ display: "flex", gap: "20px", alignItems: "flex-end", justifyContent: "space-between" }}>
                    <div className="mobile-ship-body" style={{ width: "calc(100% - 80px)" }}>
                        <div className="mobile-ship-thumb">
                            {item.imageUrl ? (
                                <img src={getImageSrc(item.imageUrl)} alt={item.productName} />
                            ) : (
                                <div className="mobile-ship-thumb-placeholder" aria-hidden>
                                    <svg viewBox="0 0 24 24" width="20" height="20">
                                        <path
                                            d="M4 5h16v14H4z"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                        />
                                        <path
                                            d="M8 13l3-3 5 6H6z"
                                            fill="currentColor"
                                        />
                                    </svg>
                                </div>
                            )}
                        </div>

                        <div className="mobile-ship-info">
                            <div className="mobile-ship-title" title={`[${item.productCode}] ${item.productName}`}>
                                <span className="mobile-ship-code">[{item.productCode}]</span>
                                {item.productName}
                            </div>

                            <div>
                                <div className="mobile-ship-meta" style={{height:"15px"}}>
                                    {item.name} · {item.tel}
                                    {item.invoiceNo ? ` · ${item.invoiceNo}` : ""}
                                </div>
                                <div className="mobile-ship-meta">
                                    {item.email}
                                </div>
                            </div>
                            {item.address && (
                                <div className="mobile-ship-addr" title={item.address}>
                                    {item.address}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* 하단: 액션 (추후 배송완료 API 연동 시 표시) */}
                    {false && (
                        <footer className="mobile-ship-actions" style={{ width: "80px" }}>
                            <button
                                type="button"
                                className={`mobile-ship-btn ${shipped ? "is-done" : "is-primary"}`}
                                onClick={handleToggle}
                            >
                                {shipped ? "완료됨" : "배송완료"}
                            </button>
                        </footer>
                    )}
                </div>
            </article>
        </div>
    );
}

const Excel = (excelData) => {
    const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const excelFileExtension = '.xlsx';
    const excelFileName = `거래내역`;

    const ws = XLSX.utils.aoa_to_sheet([
        [
            "NO", "MID", "거래일시", "취소일시", "거래상태", "거래금액", "결제서비스", "결제구분", "구매자명", "카드", "할부", "상품명", "주문번호", "거래번호"
        ]
    ]);
    excelData.map((data) => {
        XLSX.utils.sheet_add_aoa(
            ws,
            [
                [
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.NO },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.MID },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래일시 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.취소일시 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래상태 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래금액 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.결제서비스 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.결제구분 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.구매자명 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.카드 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.할부 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.상품명 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.주문번호 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래번호 }
                ]
            ],
            { origin: -1 }
        );
        ws['!cols'] = [
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 }
        ]
        return false;
    });
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelButter = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const excelFile = new Blob([excelButter], { type: excelFileType });
    FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
};

export default UrlHistory;